// extracted by mini-css-extract-plugin
export default {"close":"modalSuccess_close__dMCe8","successText":"modalSuccess_successText__lFawY","closeButin":"modalSuccess_closeButin__f+x5q"};